// ScanLineaRowXL - Sprint 44 Fase 3 Vista 7.
// Fila de producto con barra de progreso visual para picking/packing.
// Tokens + dark mode + XLBadge para estado.
import { useEffect } from 'react';
import { ensureKeyframes, injectCSS } from '../../design/motion';
import XLBadge from '../xl/XLBadge';

const CSS_ID = 'xl-scan-row-css';
const CSS = `
.xl-scan-row {
  background: var(--xl-color-surface);
  border: 1px solid var(--xl-color-border);
  border-radius: var(--xl-radius-lg);
  box-shadow: var(--xl-shadow-sm);
  padding: 14px 16px;
  display: flex; align-items: center; gap: 14px;
  font-family: var(--xl-font-sans);
}
.xl-scan-row__main { flex: 1; min-width: 0 }
.xl-scan-row__hd {
  display: flex; align-items: center; gap: 8px; margin-bottom: 8px;
  flex-wrap: wrap;
}
.xl-scan-row__sku {
  font-family: var(--xl-font-mono);
  font-size: 11px;
  color: var(--xl-color-text-muted);
}
.xl-scan-row__name {
  font-size: 14px; font-weight: 500;
  color: var(--xl-color-text);
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
  flex: 1; min-width: 0;
}
.xl-scan-row__bar {
  width: 100%; height: 6px;
  background: var(--xl-color-surface-alt);
  border-radius: var(--xl-radius-full);
  overflow: hidden;
}
.xl-scan-row__bar-fill {
  height: 100%;
  border-radius: inherit;
  transition: width 220ms cubic-bezier(0.4,0,0.2,1);
}
.xl-scan-row__bar-fill--pendiente { background: var(--xl-color-text-muted) }
.xl-scan-row__bar-fill--parcial   { background: var(--xl-color-warning) }
.xl-scan-row__bar-fill--completo  { background: var(--xl-color-success) }

.xl-scan-row__counter {
  text-align: right; flex-shrink: 0;
}
.xl-scan-row__counter-num {
  font-family: var(--xl-font-mono);
  font-size: 22px; font-weight: 700;
  color: var(--xl-color-text);
  line-height: 1;
}
.xl-scan-row__counter-req {
  color: var(--xl-color-text-muted);
}
.xl-scan-row__counter-pct {
  font-size: 11px;
  color: var(--xl-color-text-muted);
  margin-top: 4px;
  font-family: var(--xl-font-mono);
}
`;

const ESTADO_VARIANT = {
  pendiente: 'neutral',
  parcial:   'warning',
  completo:  'success',
};

const ESTADO_LABEL = {
  pendiente: 'Pendiente',
  parcial:   'Parcial',
  completo:  'Completo',
};

export default function ScanLineaRowXL({
  linea,
  field_req = 'cantidad_requerida',
  field_ok = 'cantidad_pickeada',
}) {
  useEffect(() => { ensureKeyframes(); injectCSS(CSS_ID, CSS); }, []);

  const req = Number(linea[field_req] || 0);
  const ok = Number(linea[field_ok] || 0);
  const pct = req > 0 ? Math.min(100, Math.round((ok / req) * 100)) : 0;
  const estado = linea.estado || 'pendiente';
  const fillCls = 'xl-scan-row__bar-fill xl-scan-row__bar-fill--' + estado;

  return (
    <div className="xl-scan-row">
      <div className="xl-scan-row__main">
        <div className="xl-scan-row__hd">
          {linea.producto_sku && (
            <span className="xl-scan-row__sku">{linea.producto_sku}</span>
          )}
          <span className="xl-scan-row__name">
            {linea.producto_nombre || ('#' + linea.producto_id)}
          </span>
          <XLBadge variant={ESTADO_VARIANT[estado] || 'neutral'} dot>
            {ESTADO_LABEL[estado] || estado}
          </XLBadge>
        </div>
        <div className="xl-scan-row__bar" aria-hidden="true">
          <div className={fillCls} style={{ width: pct + '%' }} />
        </div>
      </div>
      <div className="xl-scan-row__counter">
        <div className="xl-scan-row__counter-num">
          {ok}<span className="xl-scan-row__counter-req">/{req}</span>
        </div>
        <div className="xl-scan-row__counter-pct">{pct}%</div>
      </div>
    </div>
  );
}
